/* eslint-disable camelcase */
import React from 'react';
import { PropTypes } from 'prop-types';
import {
  Descriptions,
  Card, Button,
} from 'antd';
import ReactJson from 'react-json-view';
import { useSelector } from 'react-redux';
import { TransactionStatuses, TransactionTypes } from '../../constants/System';
import {
  COLLECTION_REFUND_BY_ADMIN, TRANSACTION_CHARGEBACKS, TRANSACTION_REFUNDS, TRANSACTION_SETTLEMENTS,
} from '../../constants/resources';
import Can from '../../util/can';

const expectedCharge = (data) => {
  const x = ((data.transaction_amount * data.pct_charge * 0.01) + data.fixed_charge);
  return Number(Math.ceil(x * 100) / 100);
};

const TransactionDetailsForModal = ({
  selectedTransaction, handleUpdateTransactionStatus,
  handleRefundTransaction, handleCheckTransactionStatus,
  handleTriggerWebhook,
}) => {
  let data = { ...selectedTransaction };
  if (selectedTransaction && selectedTransaction.merchant_request_payload) {
    data = { ...selectedTransaction, merchant_request_payload: undefined };
  }

  const {
    checkingStatus,
    triggerWebhook,
  } = useSelector(({ transactions }) => transactions.allTransactions);

  const cantUpdateDisbursement = () => (TransactionTypes.DISBURSEMENT === data.transaction_type)
    && ([
      TransactionStatuses.CONFIRMING,
      TransactionStatuses.FAILED,
    ]).includes(data.transaction_status);

  const cantUpdateCollection = () => (TransactionTypes.COLLECTION === data.transaction_type)
    && ([
      TransactionStatuses.CONFIRMING,
      TransactionStatuses.FAILED,
      TransactionStatuses.COMPLETED,
    ]).includes(data.transaction_status);

  return (
    <div>
      {data && data.transaction_type === TransactionTypes.REFUND && (
        <Can I="update" a={TRANSACTION_REFUNDS}>
          <Button
            type="primary"
            className="ant-btn-sm ant-btn-background-ghost"
            onClick={() => handleUpdateTransactionStatus()}
          >
            Update Refund Status
          </Button>
        </Can>
      )}

      {data && data.transaction_type === TransactionTypes.SETTLEMENT && (
        <Can I="update" a={TRANSACTION_SETTLEMENTS}>
          <Button
            type="primary"
            className="ant-btn-sm ant-btn-background-ghost"
            onClick={() => handleUpdateTransactionStatus()}
          >
            Update Settlement Status
          </Button>
        </Can>
      )}

      {data && data.transaction_type === TransactionTypes.CHARGEBACK && (
        <Can I="update" a={TRANSACTION_CHARGEBACKS}>
          <Button
            type="primary"
            className="ant-btn-sm ant-btn-background-ghost"
            onClick={() => handleUpdateTransactionStatus()}
          >
            Update Chargeback Status
          </Button>
        </Can>
      )}

      {data && data.transaction_type === TransactionTypes.COLLECTION
        && data.transaction_status === TransactionStatuses.COMPLETED
        && (
          <Can I="create" a={COLLECTION_REFUND_BY_ADMIN}>
            <div>
              <Button
                type="primary"
                style={{ float: 'right', top: '-40px', right: '50px' }}
                className="ant-btn-sm ant-btn-background-ghost"
                onClick={() => handleRefundTransaction()}
              >
                Refund
              </Button>
            </div>
          </Can>
        )}

      {data && data._id
        && (
          <div className="justify-content-center">
            <Card>
              <div>
                Amount:
                {data?.transaction_amount}
                {' '}
                {data?.transaction_currency}
                {' '}
                (
                {data?.transaction_status}
                )
              </div>
              <br />
              <div>
                Processor:
                {data?.processor_name}
                {' '}
                (
                {data?.payment_method}
                )
              </div>
              <br />
              <div>
                Kitegateway Ref:
                {' '}
                {data?.kitegateway_reference}
              </div>
              <div>
                Processor Ref:
                {' '}
                {data?.processor_reference}
              </div>
              <br />
              {data?.transaction_id_processor_ref
                && (
                  <>
                    <div>
                      Parent Processor Ref:
                      {' '}
                      {data?.transaction_id_processor_ref}
                    </div>
                    <br />
                  </>
                )}
              <div>
                Merchant:
                {' '}
                {data?.business_name}
              </div>
              <div>
                Customer:
                {' '}
                {data?.customer_name}
                {' '}
                {`(${data?.customer_email})`}
              </div>
              <br />
              <div>
                {data
                  && (cantUpdateDisbursement() || cantUpdateCollection())
                  && (
                    <Button
                      loading={checkingStatus}
                      type="primary"
                      className="ant-btn-sm ant-btn-background-ghost"
                      onClick={() => handleCheckTransactionStatus(
                        data.processor.service_type, data.kitegateway_reference,
                      )}
                    >
                      Check and Update Status
                    </Button>
                  )}
                {data
                  && (
                    <Button
                      loading={triggerWebhook}
                      type="primary"
                      className="ant-btn-sm ant-btn-background-ghost"
                      onClick={() => handleTriggerWebhook(
                        data.kitegateway_reference,
                      )}
                    >
                      Trigger Webhook
                    </Button>
                  )}
              </div>
            </Card>
          </div>
        )}

      {data && data._id
        && (
          <div className="justify-content-center">
            <Card>
              <Descriptions layout="vertical">
                <Descriptions.Item label="More Details">
                  <ReactJson src={data} collapsed />
                </Descriptions.Item>
              </Descriptions>
            </Card>
          </div>
        )}
    </div>
  );
};

TransactionDetailsForModal.propTypes = {
  selectedTransaction: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  handleUpdateTransactionStatus: PropTypes.oneOfType([
    PropTypes.func,
  ]),
  handleRefundTransaction: PropTypes.oneOfType([
    PropTypes.func,
  ]),
  handleCheckTransactionStatus: PropTypes.oneOfType([
    PropTypes.func,
  ]),
  handleTriggerWebhook: PropTypes.oneOfType([
    PropTypes.func,
  ]),
};

TransactionDetailsForModal.defaultProps = {
  selectedTransaction: {},
  handleUpdateTransactionStatus: () => { },
  handleRefundTransaction: () => { },
  handleCheckTransactionStatus: () => { },
  handleTriggerWebhook: () => { },
};
export default TransactionDetailsForModal;
